export default __webpack_public_path__ + "static/media/minion-fail.aa288d70.mp3";